<template>
  <div id="app" class="legacy-app">
    <legacy-sunset-banner />
    <main>
      <transition mode="out-in">
        <router-view></router-view>
      </transition>
    </main>
  </div>
</template>

<script>
import LegacySunsetBanner from './core/LegacySunsetBanner.vue';
import api from '@/api';
import apiUrl from '../config/APIs';
export default {
  name: 'App',
  components: { LegacySunsetBanner },
  data() {
    return {
      section: 'Head'
    };
  },
  methods: {
    logout() {
      this.$store.commit('SET_USER', null);
      this.$store.commit('SET_TOKEN', null);

      if (window.localStorage) {
        window.localStorage.setItem('user', null);
        window.localStorage.setItem('token', null);
      }

      this.$router.push({ name: 'Login' });
    },
    checkLoginStatus(fbId) {
      let url = apiUrl.INSTAGRAM_GRAPH_API_CHECK_SESSION_AVAILBLE.replace('{fbId}', fbId);
      api
        .request('get', url, false)
        .then(response => {
          if (response.status === 200) {
            let data = response.data;
            this.handleLoginStatus(data);
          } else {
            this.handleLoginStatusUnreachable();
          }
        })
        .catch(() => this.handleLoginStatusUnreachable());
    },
    handleLoginStatus(data) {
      if (!data.success) {
        this.$swal({
          title: 'Session expired',
          text: 'Your session has expired. Please do login again!',
          type: 'warning'
        }).then(() => {
          this.logout();
        });
      }
    },
    handleLoginStatusUnreachable() {
      this.$swal({
        title: 'Error',
        text: 'There are something wrong. Please do login again!',
        type: 'error'
      }).then(() => {
        this.logout();
      });
    }
  },
  created() {
    let user = this.$store.state.user;
    if (user && user.facebookId) {
      this.checkLoginStatus(user.facebookId);
    }
    if (user && !user.id) {
      this.logout();
    }
  }
};
</script>
<style>
.v-btn {
  text-transform: none!important;
}
</style>



// WEBPACK FOOTER //
// App.vue?4abe5578